import * as React from "react";
import type { BuildPlanLine } from "../wizardTypes";
import { fmtMoney } from "../data/planMatch";
import { fmtRate } from "../data/rackRates";
import styles from "../css/SignupWizard.module.css";

type Props = { line: BuildPlanLine; children?: React.ReactNode };

export function PlanLineCard({ line, children }: Props) {
  return (
    <div className={styles.planLine}>
      <p className={styles.planLineName}>
        {line.name}
      </p>
      <p className={styles.planLinePrice}>
        {fmtMoney(line.price)}
        <span className={styles.planLinePriceSub}>/{line.period}</span>
      </p>
      <p className={styles.planLineCoverage}>{line.coverage}</p>
      {line.overageRate != null && line.overageUnit && (
        <p className={styles.planLineOverage}>
          <span className={styles.planLineOverageBadge}>Overage</span>
          {fmtRate(line.overageRate)} {line.overageUnit}
        </p>
      )}
      {line.note && (
        <p className={styles.planLineNote}>{line.note}</p>
      )}
      <ul className={styles.planLineFeatures}>
        {line.features.map((f, i) => (
          <li key={i}>{f}</li>
        ))}
      </ul>
      {children}
    </div>
  );
}
